import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isAcceptBtnMain } = {}) => ({
  buttons: {
    backgroundColor: 'white',
    bottom: 0,
    display: 'flex',
    gap: theme.spacing(4),
    justifyContent: 'flex-end',
    left: 0,
    marginTop: 'auto',
    padding: '24px 0 16px 12px',
    position: 'sticky',
    width: '100%',
    zIndex: 1,
    '& button': {
      maxHeight: 44,
    },
    '& #reject-button': {
      color: isAcceptBtnMain ? theme.palette.primary1 : 'white',
    },
    '& .Mui-disabled#accept-button': {
      color: '#929A92 !important',
    },
    '& #accept-button': {
      color: !isAcceptBtnMain ? theme.palette.primary1 : 'white',
      width: 110,
    },
    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing(2),
      '& #accept-button': {
        width: 200,
      },
    },
    [theme.breakpoints.downLandscape('sm')]: {
      ...(theme.isMobileDevice && {
        paddingBottom: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5),
      }),
    },
  },
}));
